import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TypeDocumentChampGarantieService } from "../../core/service/type-document-champ-garantie.service";
import { ChampSourceGarantie } from "../../core/model/garanties/ChampSourceGarantie";
import { AddChampSourceGarantieComponent } from "./add-champ-source-garantie/add-champ-source-garantie.component";

@Component({
  selector: "app-champ-form-garantie",
  templateUrl: "./champ-form-garantie.component.html",
  styleUrls: ["./champ-form-garantie.component.scss"],
})
export class ChampFormGarantieComponent implements OnInit {
  champSourceGaranties: ChampSourceGarantie[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _champSourceGarantieService: TypeDocumentChampGarantieService
  ) {}

  ngOnInit() {
    this.getChampSourceGaranties();
  }

  getChampSourceGaranties() {
    this._champSourceGarantieService
      .getChampSourceGaranties()
      .subscribe((data) => {
        this.champSourceGaranties = data;
      });
  }

  deleteDetail(group: ChampSourceGarantie) {}

  editDetail(champSourceGarantie: ChampSourceGarantie) {
    const modalRef = this.modalService.open(AddChampSourceGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class",
    });

    modalRef.componentInstance.champSourceGarantie = champSourceGarantie;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getChampSourceGaranties();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addChampSourceGarantie() {
    const modalRef = this.modalService.open(AddChampSourceGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "type-document-garantie-modal",
    });
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getChampSourceGaranties();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
